import { render } from "./DaftarLogin.vue?vue&type=template&id=4f5f3e48"
import script from "./DaftarLogin.vue?vue&type=script&lang=js"
export * from "./DaftarLogin.vue?vue&type=script&lang=js"

import "./DaftarLogin.vue?vue&type=style&index=0&id=4f5f3e48&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__